import React from 'react'
import { Box, Typography, Paper, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MISBulkUpload from '../components/mis/MISBulkUpload'

const MISBulkUploadPage: React.FC = () => {
  const navigate = useNavigate()
  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <div>
          <Typography variant="h4">MIS Bulk Upload</Typography>
          <Typography variant="body2">Upload MIS rows via CSV/XLSX with From/To dates</Typography>
        </div>
        <Button onClick={() => navigate('/mis')} variant="outlined">Back to MIS List</Button>
      </Box>

      <Paper style={{ padding: 16 }}>
        <MISBulkUpload onDone={() => {/* intentionally left blank; user returns to list manually */}} />
      </Paper>
    </Box>
  )
}

export default MISBulkUploadPage